<template>
  <v-layout column class="inner-pages">
    <Header  />
    <v-flex class="sfh-login-form background-image text-center signup-page" >
      <v-stepper v-model="e1" class="elevation-0" style="background: transparent;">
        <v-stepper-header class="elevation-0 px-4" >
          <v-stepper-step :complete="e1 > 1" step="1"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2"></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3"></v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <confirm-my-phone
              v-if="step === 'confirm-my-phone'"
              page="Register"
            />
            <phone-code-verification
              v-if="step === 'phone-verification'"
              page="Register"
            />
          </v-stepper-content>

          <v-stepper-content step="2">
            <confirm-name
              page="Register"
            />
          </v-stepper-content>

          <v-stepper-content step="3">
            <get-name-and-pwd
              page="Register"
            />
          </v-stepper-content>

          <v-stepper-content step="4">
            <update-profile
              page="Register"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-layout>
</template>

<script>
import Header from '@/components/layouts/Header'
import GetNameAndPwd from '@/components/views/sign-up/GetLocationInfo'
import UpdateProfile from '@/components/views/sign-up/UpdateProfile'
import ConfirmMyPhone from '@/components/views/sign-up/ConfirmMyPhone'
import PhoneCodeVerification from '@/components/views/sign-up/PhoneCodeVerification'
import {mapGetters, mapMutations} from 'vuex'
import ConfirmName from '@/components/views/sign-up/ConfirmName'
import crypto from '@/mixins/crypto'

export default {
  name: 'Register',
  components: {
    ConfirmName,
    PhoneCodeVerification,
    ConfirmMyPhone,
    GetNameAndPwd,
    Header,
    UpdateProfile
  },
  data () {
    return {
      e1: 1
    }
  },
  computed: {
    step () {
      return this.$route.params.step
    },
    ...mapGetters('registration', ['getUserDetails'])
  },
  created () {
    this.setE1(this.$route.params.step)
    this.$store.dispatch('registration/checkEmailExists', localStorage.getItem('email')).then(response => {
      const fName = this.getUserDetails.first_name
      const lName = this.getUserDetails.last_name
      const email = this.getUserDetails.email
      // eslint-disable-next-line no-console
      console.log('fName', fName, lName, response.data.firstName, response.data.lastName)
      if (fName === '' || lName === '' || email === '') {
        this.setUser({
          ...this.getUserDetails,
          email: this.encryptData(localStorage.getItem('email')),
          first_name: response.data.firstName,
          last_name: response.data.lastName
        })
      }
    })

    setTimeout(() => {
      this.$store.commit('setIsCompactHeader', false)
    }, 50)
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    setE1 (newVal) {
      switch (newVal) {
        case 'confirm-my-phone': this.e1 = 1
          break
        case 'phone-verification': this.e1 = 1
          break
        case 'confirm-name': this.e1 = 2
          break
        case 'get-location-info': this.e1 = 3
          break
        case 'update-profile': this.e1 = 4
          break
        default: this.e1 = 1
      }
    }
  },
  watch: {
    step (newVal) {
      this.setE1(newVal)
    }
  },
  mixins: [crypto]
}
</script>



// WEBPACK FOOTER //
// src/components/views/auth/Register.vue